import React, { useEffect, useState } from 'react';
import { Divider, Space } from 'antd';

import { Trans, useTranslation } from 'react-i18next';

// import i18n from 'i18next';
import './styles.css';
import Header from '../../../components/header/Header';
import { useNavigate } from 'react-router-dom';
import CenterLoading from '../../../components/CenterLoading/CenterLoading';
import { Auth } from 'aws-amplify';
import { CognitoHostedUIIdentityProvider } from '@aws-amplify/auth';
import { DISABLE_SOCIAL_LOGIN, IS_IN_PURCHASE, localStorageKeys } from '../../../utils/Constants';

import icFacebook from '../../../assets/imgs/f_logo_RGB-Blue_72.png';
import icGoogle from '../../../assets/imgs/g-logo.png';
import icApple from '../../../assets/imgs/Logo - SIWA - Left-aligned - Black - Large.svg';
// import icAmazon from '../../assets/imgs/ic_amazon.svg?react';
import icMail from '../../../assets/imgs/ic_mail.svg';
import useDevice from '../../../hooks/useDevice';
import { getValueByLanguage, showNotificationDialog } from '../../../utils';
import CustomAntButton from '../../../components/CustomAntButton/CustomAntButton';
import { useHomeUrls } from '../../../hooks/useHomeUrls';

/**
 * 図101-1 ログインメニュー画面
 */
const LoginScreen = () => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    let isCallSignInWithProvider = false;
    let providerNameSaved = '';
    const { createDeviceId } = useDevice();
    const [isLoading, setIsLoading] = useState(false);
    const [lastLoginMethod, setLastLoginMethod] = useState<string | null>(null);
    const { privacy, terms } = useHomeUrls();

    useEffect(() => {
        const method = localStorage.getItem('LAST_LOGIN_METHOD');
        if (method) {
            switch (method) {
                case 'Email':
                    setLastLoginMethod(t('user-info.mail'));
                    break;
                case CognitoHostedUIIdentityProvider.Google:
                    setLastLoginMethod('Google');
                    break;
                case CognitoHostedUIIdentityProvider.Facebook:
                    setLastLoginMethod('Facebook');
                    break;
                case CognitoHostedUIIdentityProvider.Apple:
                    setLastLoginMethod('Apple');
                    break;
                case CognitoHostedUIIdentityProvider.Amazon:
                    setLastLoginMethod('Amazon');
                    break;
                default:
                    break;
            }
        }
    }, []);

    /**
     * ログインのタイプの処理
     *
     * @param {CognitoHostedUIIdentityProvider} provider
     */
    const signInWithProvider = async (providerName: CognitoHostedUIIdentityProvider) => {
        if (!isCallSignInWithProvider || providerNameSaved !== providerName) {
            isCallSignInWithProvider = true;
            providerNameSaved = providerName;
            //ローディングを表示
            setIsLoading(true);
            try {
                // ソーシャルログインのフラグを作成
                localStorage.setItem('isSocialLogin', 'true');

                await Auth.federatedSignIn({ provider: providerName });
                createDeviceId();

                const delay = 3 * 1000;
                setTimeout(() => {
                    //ローディングを非表示
                    setIsLoading(false);
                    isCallSignInWithProvider = false;
                }, delay);
            } catch (error) {
                const delay = 3 * 1000;
                setTimeout(() => {
                    //ローディングを非表示
                    setIsLoading(false);
                    isCallSignInWithProvider = false;
                }, delay);
                // ソーシャルログイン時にエラーが発生した場合
                localStorage.removeItem('isSocialLogin');
                // 2b-E1 ログイン時エラー
                console.log(error);

                showNotificationDialog(
                    'error',
                    'social_login_failed',
                    t('notification.title'),
                    'social login error' + JSON.stringify(error, Object.getOwnPropertyNames(error)),
                );
            }
        }
    };

    const onTermsOfUseClick = () => {
        const termsUrl = getValueByLanguage(terms, i18n.language) || terms?.en;
        window.open(termsUrl, '_blank', 'noopener,noreferrer');
    };

    const onPrivacyPolicyClick = () => {
        const ticketUsageUrl = getValueByLanguage(privacy, i18n.language) || privacy?.en;
        window.open(ticketUsageUrl, '_blank', 'noopener,noreferrer');
    };

    return (
        <>
            {isLoading && <CenterLoading overFooter={true} />}
            {/* 図2-1から図101-1遷移後、購入画面（図2-1）に戻る・他の場合は、マイページ（図100-1）に遷移する */}
            {localStorage.getItem(IS_IN_PURCHASE) != null || localStorage.getItem(localStorageKeys.LOGIN_FLOW) ? (
                <Header title={t('header.login')} />
            ) : (
                <Header title={t('header.login')} redirect="/profile" />
            )}
            <div className="content-footer-container scrollable login-container">
                <div className="login-agree-terms-of-use">
                    <span>
                        <Trans
                            i18nKey="login.agree-terms-of-use"
                            components={{
                                link_terms: (
                                    <span
                                        style={{
                                            color: 'rgba(80, 180, 240, 1)',
                                            borderBottom: '1px solid rgba(80, 180, 240, 1)',
                                        }}
                                        onClick={onTermsOfUseClick}
                                    />
                                ),
                                link_privacy: (
                                    <span
                                        style={{
                                            color: 'rgba(80, 180, 240, 1)',
                                            borderBottom: '1px solid rgba(80, 180, 240, 1)',
                                        }}
                                        onClick={onPrivacyPolicyClick}
                                    />
                                ),
                            }}
                        />
                    </span>
                </div>
                {lastLoginMethod && (
                    <div className="last-login-method">{t('login.last-method-login', { lastLoginMethod })}</div>
                )}
                <Space direction="vertical" style={{ width: '100%', marginTop: 20 }} size={15}>
                    <CustomAntButton
                        type="outlined"
                        className="btn-login mail"
                        icon={<img src={icMail} alt="ic-mail" />}
                        onClick={() => {
                            navigate('email');
                        }}
                    >
                        <span className="title">{t('login.email')}</span>
                    </CustomAntButton>
                    {!DISABLE_SOCIAL_LOGIN && (
                        <>
                            <CustomAntButton
                                type="outlined"
                                className="btn-login btn-apple"
                                icon={<img src={icApple} alt="ic-apple" />}
                                onClick={() => signInWithProvider(CognitoHostedUIIdentityProvider.Apple)}
                            >
                                <span className="title">{t('login.apple')}</span>
                            </CustomAntButton>
                            <CustomAntButton
                                type="outlined"
                                className="btn-login"
                                icon={<img src={icGoogle} alt="ic-google" />}
                                onClick={() => signInWithProvider(CognitoHostedUIIdentityProvider.Google)}
                            >
                                <span className="title">{t('login.google')}</span>
                            </CustomAntButton>
                            <CustomAntButton
                                type="outlined"
                                className="btn-login btn-amazon"
                                icon={
                                    <img
                                        src="https://images-na.ssl-images-amazon.com/images/G/01/lwa/btnLWA_gold_64x64.png"
                                        alt="ic-amazon"
                                    />
                                }
                                onClick={() => signInWithProvider(CognitoHostedUIIdentityProvider.Amazon)}
                            >
                                <span className="title">{t('login.amazon')}</span>
                            </CustomAntButton>
                            <CustomAntButton
                                type="outlined"
                                className="btn-login"
                                icon={<img src={icFacebook} alt="ic-facebook" />}
                                onClick={() => signInWithProvider(CognitoHostedUIIdentityProvider.Facebook)}
                            >
                                <span className="title">{t('login.facebook')}</span>
                            </CustomAntButton>
                        </>
                    )}
                    <Divider>{t('login.or')}</Divider>
                    <CustomAntButton
                        type="outlined"
                        className="btn-login signup"
                        onClick={() => {
                            navigate('register');
                        }}
                    >
                        <span className="title">{t('login.register')}</span>
                    </CustomAntButton>
                </Space>
            </div>
        </>
    );
};

export default LoginScreen;
